//这里存储所有的接口
//一共20个接口，20和21重复了
let mcbw = '/mcbw'; 

// let mcbw = 'http://192.168.1.36:8080' //攀旗本地

//登录接口
const login = mcbw + '/users/login';
const verificationCode = mcbw + '/users/verification_code';
const verify = mcbw + '/users/forget/verify';
export {login, verificationCode, verify}
// ----------------------------------------
// 顶部获取单位列表接口
const getDepartList = mcbw + '/departments/owner';
// 左边三个图表的接口（6个）
const left_top1 = mcbw + '/alarm_stats/police_situation';         //当前报警

const hj_sum = mcbw + '/dep_stats/run_statistics';                //当前火警数量

const left_top2 = mcbw + '/part_data_statistic/historical_alarm';         //历史报警

const left_top3 = mcbw + '/part_data_statistic/historical_warning';       //历史预警

const left_mid = mcbw + '/part_data_statistic/stateTrend';                //状态趋势

const left_bot = mcbw + '/patrol_stats/patrol';                 //巡查

// const left_bot2 = mcbw + '/department_data_statistic/drill';              //演练

export {left_top1, hj_sum, left_top2, left_top3, left_mid, left_bot, getDepartList};

// ------------------------------------
// 中间下 两个接口（2个）

const bottom_mid = mcbw + '/alarm_stats';                      //报警信息列表

const bottom_right = mcbw + '/dep_stats/map_dep_count';             //右下角图例
const bottom_left = mcbw + '/dep_stats/map_resources_count'; //右下角图例

export {
    bottom_mid,
    bottom_right,
    bottom_left
};

// ----------------------------------
// 中间上 左边圆（1个）

const top_left = mcbw + '/dep_stats/run_statistics';                //中间上左边圆

export {top_left};

//安全指数
const safezhishu=mcbw +'/departments/safety_index_all';
export {safezhishu};

// -----------------------------------
// 右边三个图表的接口（5个）

const right_top1 = mcbw + '/dep_stats/dep_statistics';              //右边上联网单位分布

// const right_mid1 = mcbw + '/part_data_statistic/alarm';                   //右边中间 报警统计图
const right_mid  = mcbw + '/warn_stats/alarm';                   //右边中间 报警统计图

// const right_mid2 = mcbw + '/part_data_statistic/warning';                 //右边中间 预警统计图

// const right_bot1 = mcbw + '/part_data_statistic/alarm_unit';              //右边下 报警
const right_bot   = mcbw + '/dep_stats/alarm_unit';           //右边下 报警

// const right_bot2 = mcbw + '/part_data_statistic/warning_unit';            //右边下 预警

const fx_url = mcbw + '/risk_report/rank';                //风险
const noRes_url = mcbw + '/alarm_stats/rank_no_respond';        //未响应
export {right_top1, right_mid, right_bot, fx_url, noRes_url};

// --------------
// 地图上初始化图标（1个）

const tubiaoInit = mcbw + '/dep_stats/map_dep_statistics';          //地图显示图标 初始化
const tubiaoInitLeft = mcbw + '/dep_stats/map_resources_count_detail'; //地图显示图标 初始化
const tubiaoInitLeftDetail = mcbw + '/dep_stats/map_resources_info'; //地图显示图标 初始化
export {
    tubiaoInit,
    tubiaoInitLeft, tubiaoInitLeftDetail
};

// --------------
// 所属区域信息（1个）

const personData = mcbw + '/dep_stats/area';                       //获取监控中心所属区域信息

export {personData};

// --------------
// 点击图例，点击弹窗单位列表接口（2个）

const tuli_click = mcbw + '/dep_stats/map_dep_count_detail';       //点击图例，弹出单位列表弹窗

const danweiList_click = mcbw + '/dep_stats/dep_event_detail';     //点击单位名称，下面报警信息列表变化

export {tuli_click, danweiList_click};

// -------------
// 点击下方报警信息列表，弹窗内容数据接口（2个）

const layer_data = mcbw + '/alarm_stats/alarm_detail';               //点击报警信息列表弹窗内容

const building_map_conf = mcbw + '/building_map_conf/building/';

export { layer_data, building_map_conf};


// 获取百度语音token
const voice_broadcast = mcbw + '/dep_stats/voice_addr'

export {voice_broadcast}


// 获取报警弹窗视频、图片链接
const tuisong_btn = mcbw + '/screen_monitors/info_graphic/'              //mqtt推送过来报警信息查询视频和图片链接

export {tuisong_btn}


//值守大屏左上，左中修改接口, 接口地址都一样，传递的值 一个是 24，一个是48

//左数量
//测试地址
const zs_left_count = mcbw + '/dep_stats/overtime/count';
//左时间
const zs_left_time = mcbw + '/dep_stats/overtime/time';

export {zs_left_count, zs_left_time}


// //全局接口
// const dw_riskReport_list = mcbw + '/screen_monitors/risk_report';
//
// // 单位风险报告
// const fengxian_report = mcbw + '/page/risk_report';

const fengxian_report = mcbw + '/risk_report';
const risk_report = mcbw + '/risk_report/single_org';

export {fengxian_report, risk_report};

const device_stat = mcbw + '/device_statistic/device_stat';
export {device_stat};


const company_list = mcbw + '/departments/owner';
const area_list = mcbw + '/areas/org_areas'; //所属区域
const indus_list = mcbw + '/dictionary_datas/industryCategory/data'; //所属行业
const blcok_sum = mcbw + '/homes/data_statistics'; //基础信息按钮及数量
const userList = mcbw + '/users'; //人员信息列表
const eduInfo = mcbw + '/dictionary_datas/levelEducationCode/data'; //文化程度
const importantParts = mcbw + '/important_parts'; //重点部位列表
const buildings = mcbw + '/buildings'; //建筑构物列表
const buildingDocuments = mcbw + '/building_documents'; //相关图档列表
const surroundInfo = mcbw + '/surround_info'; //周边资源列表
const surroundInfo1 = mcbw + '/dangerous_goods'; //危险品
const surroundInfo2 = mcbw + '/gas_stations'; //加油站
const surroundInfo3 = mcbw + '/periphery_water_source'; //周边水源
const surroundInfo4 = mcbw + '/building_emergency_exits'; //出入口
const surroundInfo5 = mcbw + '/refuge_areas'; //避难地
const surroundInfo6 = mcbw + '/height_limits'; //限高杆
const surroundInfo7 = mcbw + '/mini_fire_stations'; //微型消防站

const reservePlan = mcbw + '/reserve_plan'; //预案管理列表
const camerasMonitor = mcbw + '/cameras/monitor'; //视频监控列表
const importantPartType = mcbw + '/dictionary_datas/importantPartType/data'; //重点部位类型

const contBlockUrl = {
    xfBlock: mcbw + '/homes/alarm_count', //消防运行情况, 接口一样，传参不同
    // 消防运行 列表接口
    hjList: mcbw + '/alarm_manage/fire', // 火警列表
    bjList: mcbw + '/alarm_manage/fire', //bj
    yjList: mcbw + '/alarm_manage/warn', //yj
    gzList: mcbw + '/alarm_manage/fault', //gz


    deviceTypeBlock: mcbw + '/homes/device/types',  //设备总体情况，类别展示
    deviceBlock: mcbw + '/homes/details_count', //设备总体情况
    
    xfzList: mcbw + '/fire_control_hosts', //消防主机列表
    xfEventsTab1: mcbw + '/auto_fire_alarms/fire_alarm', //消防主机 操作 事件统计 火灾报警信息
    // "pageSize":10,"currentPage":1,"alarmType":0,"orgId":null,"sortFields":"ctime"
    xfEventsTab2: mcbw + '/auto_fire_alarms/fault', //消防主机 操作 事件统计 故障信息
    // "pageSize":10,"currentPage":1,"orgId":null,"sortFields":"ctime"
    
    deviceDetail: mcbw + '/devices/', //电气火灾监控 消防水 独立探测器，详情接口
    dwDeviceList: mcbw + '/devices/org_devices',//单位设备列表

    typeList: mcbw + '/exception_types/special', //火警，报警
    typeList1: mcbw + '/exception_types', // 预警，故障
    
    eventsList1: mcbw + '/alarm_manage/fire', //报警 事件记录 列表接口
    eventsList2: mcbw + '/alarm_manage/warn', //预警 事件记录 列表接口
    eventsList3: mcbw + '/hidden_hazards', //隐患 事件记录 列表接口
    eventsList4: mcbw + '/alarm_manage/fault', //故障 事件记录 列表接口



    deviceEchart: mcbw + '/homes/state_details_count', //echart图
    deviceEchart_list: mcbw + '/device_parts', //echart图点击接口
    deviceNormalList: mcbw + '/host_parts', //消防主机正常列表
    deviceSpList: mcbw + '/cameras', //视频列表
    deviceXjList: mcbw + '/patrol_cards', //巡检列表

    
    xcBlock: mcbw + '/patrol_stats', //人员管理--巡查巡检任务
    xcList: mcbw + '/patrol_records/overview', //人员管理--巡查巡检任务点击列表

    yhBlock: mcbw + '/hidden_stats/hidden', //人员管理-- 隐患
    yhList: mcbw  +'/hidden_hazard', //人员管理-- 隐患列表

    cgBlock: mcbw + '/inspect_records/check_checked_stats', //人员管理--查岗
    cgEchart: mcbw + '/inspect_records', //查岗 echart

    //查岗获取table数据
    cgCheck: mcbw + '/inspect_records/check',  //查岗 自查
    cgChecked: mcbw + '/inspect_records/checked', //查岗 被查
    cgLeave: mcbw + '/inspect_records/off_inspect', //查岗 离岗
    cgVideo: mcbw + '/cameras/duties', //值班视频

    
    pxBlock: mcbw + '/done_tasks', //人员管理--培训演练
    pxEchart: mcbw + '/done_tasks/train_drill_stats', //培训演练echart图
    pxList: mcbw + '/done_tasks/task_list', //培训列表
    px_ylList: mcbw + '/done_tasks/task_list', //演练列表



    bjType:mcbw + '/exception_types/special', //报警类型字典项
    yjGzType:mcbw + '/exception_types', //预警故障类型字典项


    buildList: mcbw + '/buildings', //搜索条件 建筑列表
    buildFloor: mcbw + '/buildings/floors/', // 搜索条件 楼层号
    deviceStatus: mcbw + '/dictionary_datas/partStateCode/data', //搜索条件 装置状态
    companyList: mcbw + '/inspect_records/sponsor', //搜索条件 发起单位
    hostList: mcbw + '/homes/host_count', //搜索条件，主机列表
}



export {
    company_list,
    area_list,
    indus_list,
    blcok_sum,
    userList,
    eduInfo,
    importantParts,
    buildings,
    buildingDocuments,
    surroundInfo,
    surroundInfo1, surroundInfo2, surroundInfo3, surroundInfo4, surroundInfo5, surroundInfo6, surroundInfo7, reservePlan,
    camerasMonitor,
    contBlockUrl,
    importantPartType
}

let identityAuth = '/as/identity_auth/token';
export {identityAuth}


// WEBPACK FOOTER //
// ./src/assets/js/url.js